"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SKETCH_OPTIONS = exports.DEFAULT_FRACTURE_OPTIONS = exports.DEFAULT_PAIN_OPTIONS = exports.DEFAULT_CUT_OPTIONS = exports.DEFAULT_GROWTH_OPTIONS = exports.DEFAULT_SPURS_OPTIONS = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
exports.DEFAULT_SPURS_OPTIONS = {
    type: bridge_schema_1.ToolType.SpursCluster,
    size: 0,
    particleSize: 50,
};
exports.DEFAULT_GROWTH_OPTIONS = {
    size: 2,
    particleSize: 75,
    opacity: 0,
    color: '213,141,148',
};
exports.DEFAULT_CUT_OPTIONS = {
    subtype: bridge_schema_1.ToolType.Cut1Side,
    type: bridge_schema_1.ToolType.SingleCutLayer,
};
exports.DEFAULT_PAIN_OPTIONS = {
    isPulsating: true,
    type: bridge_schema_1.ToolType.PainSphere,
};
exports.DEFAULT_FRACTURE_OPTIONS = {
    size: 0,
};
exports.DEFAULT_SKETCH_OPTIONS = {
    color: '222, 0, 132',
    size: 1,
};
